import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RoadScopePage } from '../components/RoadScopePage';
import { MapContainer } from '../components/map/MapContainer';
import { POIListPage } from '../components/poi/POIListPage';
import { SurveyInfoPage } from '../components/survey/info/SurveyInfoPage';
import { StructuresOnRoute } from '../components/structures/StructuresOnRoute';
import { RoadProfilePage } from '../components/roadprofile/RoadProfilePage'; 
import { RouteTimelinePage } from '../components/roadscope/RouteTimelinePage';
import { MTMDMapView } from '../components/mtmd/MTMDMapView';
import { OSRoutePlanner } from '../components/osow/OSRoutePlanner';
import { useAuth } from '@hooks/useAuth';
import { RecordingProvider } from '@contexts/RecordingContext';
import { useSurvey } from '@contexts/SurveyContext';

const RoadScopeRoutes = () => {
  const { user } = useAuth();
  const { activeSurvey } = useSurvey();

  // Redirect to main page if no survey is active for protected routes that require it
  const RequireSurvey = ({ children }) => {
    if (!activeSurvey) {
      return <Navigate to="/roadscope" replace />;
    }
    return children;
  };

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <RecordingProvider>
      <Routes>
        <Route index element={<RoadScopePage />} />
        <Route path="map" element={<RequireSurvey><MapContainer /></RequireSurvey>} />
        <Route path="pois" element={<RequireSurvey><POIListPage /></RequireSurvey>} />
        <Route path="survey-info" element={<RequireSurvey><SurveyInfoPage /></RequireSurvey>} />
        <Route path="structures" element={<RequireSurvey><StructuresOnRoute /></RequireSurvey>} />
        <Route path="profile" element={<RequireSurvey><RoadProfilePage /></RequireSurvey>} />
        <Route path="timeline" element={<RequireSurvey><RouteTimelinePage /></RequireSurvey>} />
        <Route path="osow-planner" element={<OSRoutePlanner />} />
        <Route path="mtmd-map" element={<MTMDMapView />} />
        <Route path="*" element={<Navigate to="/roadscope" replace />} />
      </Routes>
    </RecordingProvider>
  );
};

export default RoadScopeRoutes;